import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uploadPro } from "../store/slices/property";
import { Loader } from "semantic-ui-react";
import Footer from "./footer";
import Navbarside from "../component/Navbarside";

function UploadProperty(e) {
  const [name, setName] = useState("");
  const [alertpropertyName, setAlertPropertyName] = useState("");

  const navigate = useNavigate("");
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  async function upload(e) {
    e.preventDefault();
    let item = {
      name,
    };

    dispatch(uploadPro(item))
      .unwrap()
      .then(() => {
        alert("Uploaded successfully");
        navigate("/Property");
      })
      .catch(({ message }) => {
        alert(message);
      });
  }
  const save = (e) => {
    const nameReg = /^(([A-Za-z]+[,.]?[ ]?|[a-z]+['-]?|[0-9])+)$/;
    if (nameReg.test(name)) {
      setAlertPropertyName("");
    } else if (!nameReg.test(name) && name === "") {
      setAlertPropertyName("Please enter your property type");
      e.preventDefault("");
    } else {
      setAlertPropertyName("");
    }
  };

  const clear = (e) => {
    navigate(-1);
  };

  return (
    <div>
      <Navbarside />

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row match-height">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-warning">
                        <h4
                          className="card-title"
                          id="basic-layout-form-center"
                        >
                          Add Property Type
                        </h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="px-3">
                        <form className="form" onSubmit={upload}>
                          <div className="row ">
                            <div className="col-md-6">
                              <div className="form-body">
                                <div className="form-group">
                                  <label for="placeTextarea">
                                    Property Type
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    Placeholder="Property Type"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                  />
                                  <div className="alert-message">
                                    {alertpropertyName}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {loading ? (
                            <Loader active inline />
                          ) : (
                            <>
                              <div className="form-actions center">
                                <button
                                  type="submit"
                                  className="btn btn-blue"
                                  onClick={save}
                                >
                                  <i className="icon-note"></i> Save
                                </button>
                                &nbsp;
                                <button
                                  type="reset"
                                  className="btn btn-warning mr-1"
                                  onClick={clear}
                                >
                                  <i className="icon-trash"></i> Cancel
                                </button>
                              </div>
                            </>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
export default UploadProperty;
